import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSadFace = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 34 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SadFace</title>
    <circle
      cx={17}
      cy={16.999}
      r={11.715}
      transform="rotate(180 17 17)"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.895 22.083c1.242-1.37 3.513-2.287 6.109-2.287s4.867.917 6.108 2.287"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.653 16.134c.616 0 1.116-.998 1.116-2.23 0-1.233-.5-2.232-1.116-2.232-.616 0-1.115 1-1.115 2.231 0 1.232.499 2.231 1.115 2.231ZM20.346 16.134c.616 0 1.116-.999 1.116-2.231 0-1.232-.5-2.231-1.116-2.231-.616 0-1.116.999-1.116 2.23 0 1.233.5 2.232 1.116 2.232Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIcoSadFace;
